import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    serviceTypes: {count: 0, rows: []},
    serviceTypeFilter: {},
    loading: false,
    checkDelete: {},
};

const setServiceTypeFilter = (state, action) => {
    return updateObject(state, {
        serviceTypeFilter: action.serviceTypeFilter,
    });
};

const requestServiceTypeStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchServiceTypeSuccess = ( state, action ) => {
    return updateObject( state, {
        serviceTypes: action.serviceTypes,
        loading: false
    } );
};

const requestServiceTypeFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};

const deleteServiceTypeSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const checkDeleteServiceTypeSuccess = (state, action) => {
  return updateObject(state, { 
    checkDelete: action.checkDelete,
    loading: false 
  });
}

const updateServiceTypeSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const postServiceTypeSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.REQUEST_SERVICE_TYPES_START: return requestServiceTypeStart( state, action );
        case actionTypes.FETCH_SERVICE_TYPES_SUCCESS: return fetchServiceTypeSuccess( state, action );
        case actionTypes.REQUEST_SERVICE_TYPES_FAIL: return requestServiceTypeFail( state, action );
        case actionTypes.DELETE_SERVICE_TYPES_SUCCESS: return deleteServiceTypeSuccess( state, action );
        case actionTypes.CHECK_DELETE_SERVICE_TYPES_SUCCESS: return checkDeleteServiceTypeSuccess(state, action);
        case actionTypes.UPDATE_SERVICE_TYPES_SUCCESS: return updateServiceTypeSuccess( state, action );
        case actionTypes.POST_SERVICE_TYPES_SUCCESS: return postServiceTypeSuccess( state, action );
        case actionTypes.SET_SERVICE_TYPE_FILTER: return setServiceTypeFilter(state, action);

        default: return state;
    }
};

export default reducer;